<template>
	<div class="filter-newsroom-event__activeFilterArea is-hideFilter" data-js-item="js-filter-newsroom-event-activeFilterArea" aria-expanded="false">
		<div class="filter-newsroom-event__activeFilterZone">
			<div class="filter-newsroom-event__activeFilterZoneTextArea"><span class="filter-newsroom-event__activeFilterZoneText">{{eventFilterlngtxt.title}}:</span></div>
			<div data-js-item="js-filter-newsroom-event-activeFilterZone"></div>
			<div class="filter-newsroom-event__emptyButton" data-js-item="js-filter-newsroom-event-buttonPlaceholder"><button type="button" class="filter-newsroom-event__oneFilterButton" data-js-itemId="empty" data-js-zoneId="empty" data-js-item="js-filter-newsroom-event-oneFilterButton">placeholder</button></div>
		</div>
		<div class="filter-newsroom-event__filterDelete"><button type="button" class="filter-newsroom-event__filterDeleteButton" data-js-item="js-filter-newsroom-event-filterDeleteButton">{{eventFilterlngtxt.delete_txt}}</button></div>
	</div>
</template>
<script>
export default {
  	name: "FilterNewsroomEventActiveZone",
  	components: {
  	},
  	computed: {
		eventFilterlngtxt() {
      		return this.$store.getters.lngtxt.eventfilter.eventfilteractivezone;
		}
  	}
};
</script>
